import React from 'react';


import Burger from './Burger';


const NavbarMobile = props => {
  if (!props) {
    return null;
  }
  const {data} = props;

  return (
    <div className="navigation-mobile">
      <div className="navigation-mobile__inner">
        <Burger data={data}/>
      </div>
    </div>
  )
}

export default NavbarMobile